import { Component, ViewChild, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EventviewService } from '../../services/eventview.service';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-parser-status',
  templateUrl: './parser-status.component.html',
  styleUrls: ['./parser-status.component.scss'],
  standalone: false,
})
//This shared components is a template for table data on the basis of date range
//date selected from this component is output to api
//iput is data source of table basis on date range output
export class ParserStatusComponent implements OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() tableDataSource;
  @Output() from_to_date = new EventEmitter();

  fromDate = new UntypedFormControl();
  toDate = new UntypedFormControl();
  recordSearched: boolean = false;
  displayedColumns: any[] = [
    'fileName',
    'status',
    'referenceCode',
    'applicationSource',
    'unitcode',
    'createdBy',
    'createdDate',
    'updatedBy',
    'updatedDate',
  ];
  dataSource = new MatTableDataSource();
  dataToDownload1: string;
  constructor(
    private eventView: EventviewService,
    private datepipe: DatePipe,
  ) {}

  startSearch() {
    this.from_to_date.emit({ fromDate: this.fromDate, toDate: this.toDate });
    this.recordSearched = true;
    // this.eventView.parserStatus(this.datepipe.transform(this.fromDate.value, "dd/MM/yyyy"),this.datepipe.transform(this.toDate.value, "dd/MM/yyyy")).subscribe(response => {
    //   this.recordSearched = true;
    //   this.dataSource.data = response;
    //   setTimeout(() => this.dataSource.paginator = this.paginator)
    // })
  }

  ngOnChanges() {
    this.tableDataSource.forEach((element) => {
      element.createdDate = this.datepipe.transform(new Date(element.createdDate), 'dd/MM/yyyy');
      element.updatedDate = this.datepipe.transform(new Date(element.updatedDate), 'dd/MM/yyyy');
    });
    this.dataSource.data = this.tableDataSource;
    setTimeout(() => (this.dataSource.paginator = this.paginator));
  }
  disableSearch() {
    return this.fromDate.value && this.toDate.value ? false : true;
  }
  clearTo() {
    this.toDate.setValue(null);
  }
  setMin() {
    return this.fromDate.value ? this.fromDate.value : null;
  }
  exportTOExcel() {
    //Converting the datasource and exporting as excel file

    const a: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataSource.data);
    //const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, a, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Parser_Report-' + this.datepipe.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
    //'Parser_Report-' + new Date()+'.xlsx'
  }
  // downloadTableData(data, headers) {
  //   this.dataToDownload1 = "";
  //   headers = ['fileName','status','createdBy','createdDate','updatedBy','hiringCompanyType','referenceCode','updatedDate'];
  //   let dataSourceLength = data.filteredData.length;
  //   let rowData = '';
  //   for (let i = 0; i < dataSourceLength; i++) {
  //     let line1 = '';
  //     for (let key in data.filteredData[i]) {
  //       if (line1 != '') {
  //         line1 = line1 + ','
  //       }
  //       if (data.filteredData[i][key].count>=0) {
  //         line1 = line1 + data.filteredData[i][key].count;
  //       }
  //       else {

  //         line1 = line1 + data.filteredData[i][key];
  //       }
  //     }
  //     rowData = rowData + line1 + "\r\n";
  //   }

  //   // as of now; but based on api data, row data and column dat ashould be done
  //   this.dataToDownload1 = this.dataToDownload1 + headers.join(',') + "\r\n" + rowData;

  //   if (this.dataToDownload1.split('\n').length - 1 >= 1) {
  //     const fileName = 'Parser_Report-' + new Date();
  //     let anchor1 = document.createElement('a');
  //     anchor1.href = URL.createObjectURL(new Blob([this.dataToDownload1], { type: 'text/csv' }));
  //     anchor1.download = fileName + '.csv';
  //     // start download
  //     anchor1.click();
  //   }

  // }
}
